import styled from '@emotion/styled';
import { Chip } from '@mui/material';

export const VayuChip = styled(Chip)`
  background-color: #eaeefc;
  color: #458fff;
  padding: 2px 4px;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
`;
